<template>
    <div class="page">
        <van-nav-bar
                left-text="返回"
                :title="$route.meta.title"
                @click-left="$comm.onClickLeft"
                v-show="$comm.titleShow()"  left-arrow
                fixed>
            <template #left>
                <span class="iconfont iconshang comm-rotate-270"></span>
                <span class="comm-return">返回</span>
            </template>
        </van-nav-bar>
        <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>

        <van-tabs v-model="active1" v-show="flag">
            <van-tab title="个人用户">
            </van-tab>
            <van-tab title="单位用户">
            </van-tab>
        </van-tabs>

        <van-form @submit="userOnSubmit" :validate-trigger="$trigger" v-show="active1 == 0">
            <van-cell-group title="申请信息">
                <van-field
                        readonly
                        required
                        clickable
                        :value="form.fuserno"
                        label="缴费号"
                        placeholder="请选择缴费号"
                        :rules="[{ required: true, message: '点击选择缴费号' }]">
                    <template v-if="!$route.query.readonly" #button>
                        <van-button type="info" size="mini" native-type="button" @click="choiceClick()">选择</van-button>
                    </template>
                </van-field>
                <van-field
                    readonly
                    v-model="form.fname"
                    label="用户名称"/>
                <van-field
                    readonly
                    v-model="form.ffixaddr"
                    label="用水地址"/>
                <van-field
                    readonly
                    v-model="form.fwater"
                    label="用水性质"/>
                <van-field
                    readonly
                    clickable
                    v-model="fnettype"
                    label="验表原因"
                    placeholder="请选择验表原因"
                    @click="fnettypeShow = true"
                    :required="true"
                    :rules="[{ required: true, message: '请选择验表原因'}]">
                    <template #right-icon>
                        <span class="iconfont iconxuanzesanjiao"></span>
                    </template>
                </van-field>
                <van-popup v-model="fnettypeShow" position="bottom">
                    <van-picker
                        :default-index="fnetTypeIndex"
                        title="验表原因"
                        show-toolbar
                        :columns="fnettypeColumns"
                        @cancel="fnettypeShow = false"
                        @confirm="fnettypeConfirm"
                        />
                </van-popup>
                <van-field
                    readonly
                    clickable
                    required
                    name="datetimePicker"
                    v-model="form.fappointment"
                    label="预约时间"
                    placeholder="选择预约时间"
                    @click="showPicker = true"
                    :rules="[{required: true, message: '选择预约时间'}]"
                    />
                <van-popup v-model="showPicker" position="bottom">
                    <van-datetime-picker
                        type="date"
                        v-model="currentDate"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @confirm="userOnConfirm"
                        @cancel="showPicker = false"
                    />
                </van-popup>
                <van-field
                    v-model="form.fnetmark"
                    rows="2"
                    autosize
                    label="申请说明"
                    type="textarea"
                    maxlength="500"
                    placeholder="请输入备注"
                    show-word-limit/>
            </van-cell-group>

            <van-cell-group title="证件资料">
                <van-field required name="uploader" label="产权人身份证(上传正反面2张)">
                    <template #input>
                        <van-uploader 
                            multiple 
                            :max-count="2"
                            v-model="cardPositiveMst"
                            :after-read="cardPositiveAfter"
                            @delete="cardPositiveDelete"/>
                    </template>
                </van-field>
                <van-field name="uploader" required  label="产权证明">
                    <template #input>
                        <van-uploader 
                            multiple 
                            :max-count="3"
                            v-model="propertyOwnerMst"
                            :after-read="propertyOwnerAfter"
                            @delete="propertyOwnerDelete"/>
                    </template>
                </van-field>
                <van-field name="uploader" label="其他资料">
                    <template #input>
                        <van-uploader 
                            multiple 
                            :max-count="3"
                            v-model="otherMst"
                            :after-read="otherAfter"
                            @delete="otherDelete"/>
                    </template>
                </van-field>
            </van-cell-group>


            <van-cell-group title="申请人信息">
                 <van-field
                        center
                        clearable
                        label="申请人类别"
                        placeholder=""
                        readonly>
                    <template #input>
                        <van-radio-group v-model="fnetapplytype" direction="horizontal">
                        <van-radio name="1" @click="onChanquanren">产权人</van-radio>
                        <van-radio name="2" @click="onShenqingren">申请人</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>

                <van-field 
                    :required="shenqingren && active == 0"
                    v-model="form.foper" 
                    label="姓名" 
                    placeholder="请输入姓名" 
                    v-if="shenqingren && active == 0"
                    :rules="[{required: true, message: '请输入姓名'}]"/>
                <van-field 
                    :required="shenqingren && active == 0" 
                    v-model="form.foperidno" 
                    label="身份证号" 
                    placeholder="请输入身份证号"
                    v-if="shenqingren && active == 0"
                    :rules="[{pattern: $patternId, message: '请输入正确身份证号'}]"/>
                <van-field 
                    v-model="form.fopertel" 
                    label="电话号码" 
                    placeholder="请输入电话号码"
                    v-if="shenqingren && active == 0"/>
                <van-field 
                    required
                    v-model="form.fopermobile" 
                    label="手机号码" 
                    placeholder="请输入手机号码"
                    :rules="[{pattern: $pattern, message: '请输入正确手机号码'}]"/>
                <van-field
                    required
                    v-show="modify"
                    v-model="form.smscode"
                    center
                    clearable
                    label="短信验证"
                    placeholder="请输入短信验证"
                    :rules="[{required: true, message: '请输入短信验证'}]">
                    <template #button>
                        <sms-btn :phone="form.fopermobile"></sms-btn>
                    </template>
                </van-field>
            </van-cell-group>

            <yonghuxuzhi v-show="modify" @changeChecked="changeChecked" :typecode="typecode" :ftrantype="1"></yonghuxuzhi>

            <van-button 
                v-show="modify"
                :disabled="!checked"
                block
                type="info"
                native-type="submit">
                提交
            </van-button>
        </van-form>

        <van-form @submit="unitOnSubmit" :validate-trigger="$trigger" v-show="active1 == 1">
            <van-cell-group title="申请信息">
                <van-field
                        readonly
                        required
                        clickable
                        :value="unitForm.fuserno"
                        label="缴费号"
                        placeholder="请选择缴费号"
                        :rules="[{ required: true, message: '点击选择缴费号' }]">
                    <template v-if="!$route.query.readonly" #button>
                        <van-button type="info" size="mini" native-type="button" @click="choiceClick()">选择</van-button>
                    </template>
                </van-field>
                <van-field
                    readonly
                    v-model="unitForm.fname"
                    label="用户名称"/>
                <van-field
                    readonly
                    v-model="unitForm.ffixaddr"
                    label="用水地址"/>
                <van-field
                    readonly
                    v-model="unitForm.fwater"
                    label="用水性质"/>
                <van-field
                    readonly
                    clickable
                    v-model="unitfnettype"
                    label="验表原因"
                    placeholder="请选择验表原因"
                    @click="fnettypeShow = true"
                    :required="true"
                    :rules="[{ required: true, message: '请选择验表原因'}]">
                    <template #right-icon>
                        <span class="iconfont iconxuanzesanjiao"></span>
                    </template>
                </van-field>
                <van-popup v-model="fnettypeShow" position="bottom">
                    <van-picker
                        :default-index="unitFnetTypeIndex"
                        title="验表原因"
                        show-toolbar
                        :columns="fnettypeColumns"
                        @cancel="fnettypeShow = false"
                        @confirm="unitFnettypeConfirm"
                        />
                </van-popup>
                <van-field
                    readonly
                    clickable
                    required
                    name="datetimePicker"
                    v-model="unitForm.fappointment"
                    label="预约时间"
                    placeholder="选择预约时间"
                    @click="showPicker = true"
                    :rules="[{required: true, message: '选择预约时间'}]"
                    />
                <van-popup v-model="showPicker" position="bottom">
                    <van-datetime-picker
                        type="date"
                        v-model="unitcurrentDate"
                        :min-date="unitminDate"
                        :max-date="unitmaxDate"
                        @confirm="unitOnConfirm"
                        @cancel="showPicker = false"
                    />
                </van-popup>
                <van-field
                    v-model="unitForm.fnetmark"
                    rows="2"
                    autosize
                    label="申请说明"
                    type="textarea"
                    maxlength="500"
                    placeholder="请输入备注"
                    show-word-limit/>
            </van-cell-group>

            <van-cell-group title="证件资料">
                <van-field required name="uploader" label="营业执照（统一社会信用代码）">
                    <template #input>
                        <van-uploader 
                            multiple 
                            :max-count="1"
                            v-model="businessLicenseMst"
                            :after-read="businessLicenseAfter"
                            @delete="businessLicenseDelete"/>
                    </template>
                </van-field>
                <van-field name="uploader" required  label="产权证明">
                    <template #input>
                        <van-uploader 
                            multiple 
                            :max-count="3"
                            v-model="unitpropertyOwnerMst"
                            :after-read="unitpropertyOwnerAfter"
                            @delete="unitpropertyOwnerDelete"/>
                    </template>
                </van-field>
                <van-field name="uploader" label="其他资料">
                    <template #input>
                        <van-uploader 
                            multiple 
                            :max-count="3"
                            v-model="unitotherMst"
                            :after-read="unitotherAfter"
                            @delete="unitotherDelete"/>
                    </template>
                </van-field>
            </van-cell-group>

            <van-cell-group title="申请人信息">
                <van-field 
                    required
                    v-model="unitForm.foper" 
                    label="姓名" 
                    placeholder="请输入姓名" 
                    :rules="[{required: true, message: '请输入姓名'}]"/>
                <van-field 
                    required
                    v-model="unitForm.foperidno" 
                    label="身份证号" 
                    placeholder="请输入身份证号"
                    :rules="[{pattern: $patternId, message: '请输入正确身份证号'}]"/>
                <van-field 
                    v-model="unitForm.fopertel" 
                    label="电话号码" 
                    placeholder="请输入电话号码"/>
                <van-field 
                    required
                    v-model="unitForm.fopermobile" 
                    label="手机号码" placeholder="请输入手机号码"
                    :rules="[{pattern: $pattern, message: '请输入正确手机号码'}]"/>
                <van-field
                    required
                    v-show="modify"
                    v-model="unitForm.smscode"
                    center
                    clearable
                    label="短信验证"
                    placeholder="请输入短信验证"
                    :rules="[{required: true, message: '请输入短信验证'}]">
                    <template #button>
                        <sms-btn :phone="unitForm.fopermobile"></sms-btn>
                    </template>
                </van-field>
            </van-cell-group>

            <yonghuxuzhi v-show="modify" @changeChecked="unitChangeChecked" :typecode="typecode" :ftrantype="2"></yonghuxuzhi>

            <van-button 
                v-show="modify"
                :disabled="!unitChecked"
                block
                type="info"
                native-type="submit">
                提交
            </van-button>
        </van-form>

        <van-popup
                v-model="popShow"
                class="form-pop">
            <user-select-pop :userList="userList" :isquery="0" @onSelectClick="onSelectClick"></user-select-pop>
        </van-popup>
    </div>
</template>

<script>
    import smsBtn from '@/components/smsBtn.vue'
    import UserSelectPop from '@/components/UserSelectPop.vue'

    export default {
        name: 'MeterTransferForm',
        components: {
            smsBtn,
            UserSelectPop
        },
        data() {
            return {
                typecode:211,
                active: 0,
                active1: 0,
                popShow: false,
                uploaderMst: [], // vant自带缩略图站位
                uploaderHs: [],
                uploaderOpt: [],
                masterUrls: [],
                hourseUrls: [],
                optUrls: [],
                message: '',
                radio: '1',
                form: {
                    ftrantype:1,
                    fsou:this.$comm.titleShow()?2:4,
                    fpactno:'',
                    fuserno:'',
                    fname:'',
                    ffixaddr:'',
                    fwaterid:'',
                    fwater:'',
                    fappointment:'',
                    fnettype:'',
                    fnetmark:'',
                    attach:[],
                    fnetapplytype:'1',
                    foper:'',
                    foperidno:'',
                    fopertel:'',
                    fopermobile:'',
                    smscode:''
                },
                unitForm:{
                    ftrantype:2,
                    fsou:this.$comm.titleShow()?2:4,
                    fpactno:'',
                    fuserno:'',
                    fname:'',
                    ffixaddr:'',
                    fwaterid:'',
                    fwater:'',
                    fappointment:'',
                    fnettype:'',
                    fnetmark:'',
                    attach:[],
                    fnetapplytype:'2',
                    foper:'',
                    foperidno:'',
                    fopertel:'',
                    fopermobile:'',
                    smscode:''
                },
                value: '',
                showPicker: false,
                userList: JSON.parse(localStorage.getItem('userList')),
                userInfo: {},
                isNameSame: false,

                chanquanren: true,
                shenqingren: false,
                 // 个人图片资料
                cardPositive:[], // 身份证正面
                cardAnti:[], // 身份证反
                propertyOwner:[], // 产权证明
                other:[], // 个人其他材料
                cardPositiveMst:[], // 身份证正面
                cardAntiMst:[], // 身份证反
                propertyOwnerMst:[], // 产权证明
                otherMst:[], // 个人其他材料
                currentDate: new Date(( new Date()).getTime()+1000*60*60*24),
                minDate:  new Date(( new Date()).getTime()+1000*60*60*24),
                maxDate:  new Date(( new Date()).getTime()+1000*60*60*24*15),
                fnettype:'', // 验表原因
                fnettypeShow:false,
                fnettypeColumns:[],
                fnetTypeIndex:0,
                // 单位资料
                unitfnettype:'', // 验表原因
                unitFnetTypeIndex:0,
                businessLicense:[], // 单位营业执照
                unitother:[], // 单位其他材料
                unitpropertyOwner:[], // 单位产权证明
                businessLicenseMst:[], // 单位营业执照
                unitotherMst:[], // 单位其他材料
                unitpropertyOwnerMst:[], // 单位产权证明
                unitcurrentDate: new Date(( new Date()).getTime()+1000*60*60*24),
                unitminDate:  new Date(( new Date()).getTime()+1000*60*60*24),
                unitmaxDate:  new Date(( new Date()).getTime()+1000*60*60*24*15),
                fnetapplytype:'1',
                flag:this.$route.query.busstype?false:true,
                modify: this.$route.query.modify?(this.$route.query.modify === '1'|| this.$route.query.modify === 1 ?false:true):true,
                checked:false,
                unitChecked:false
            }
        },
        mounted() {
            this.getFnetType()
            if(!this.flag){
                this.info()
            }
        },
        methods: {
            changeChecked(checked){
                this.checked = checked
            },
            unitChangeChecked(checked){
                this.unitChecked = checked
            }, 
            // 详情
            info(){
                this.$http.post(this.$api.getBussInfo, {busstype:this.$route.query.busstype,
                                                        bussno:this.$route.query.bussno}).then(res => {
                    if (res.code==='000') {
                        // 个人
                        if(res.data.ftrantype === 1 || res.data.ftrantype === '1'){
                            this.active1 = 0
                            this.form = res.data
                            this.currentDate = new Date(res.data.fappointment)
                            this.fnetTypeIndex = this.fnettypeColumns.findIndex((profile) => profile.code === res.data.fnettype)
                            this.fnettype = this.fnettypeColumns[this.fnetTypeIndex].text
                            if(res.data.fnetapplytype == 1){
                                this.fnetapplytype = '1'
                                this.onChanquanren()
                            }else{
                                this.fnetapplytype = '2'
                                this.onShenqingren()
                            }
                            // 个人图片资料
                            let result = this.$comm.serviceAttach(res.data)
                            this.cardPositive = result.cardPositive
                            this.propertyOwner = result.propertyOwner
                            this.other = result.other
                            this.cardPositiveMst = result.cardPositiveMst
                            this.propertyOwnerMst = result.propertyOwnerMst
                            this.otherMst = result.otherMst
                        }else{
                            // 单位
                            this.active1 = 1
                            this.unitForm = res.data
                            this.unitcurrentDate = new Date(res.data.fappointment)
                            this.unitFnetTypeIndex = this.fnettypeColumns.findIndex((profile) => profile.code === res.data.fnettype)
                            this.unitfnettype = this.fnettypeColumns[this.unitFnetTypeIndex].text
                            // 单位图片资料
                            let result = this.$comm.serviceAttach(res.data)
                            this.businessLicense = result.businessLicense
                            this.unitpropertyOwner = result.unitpropertyOwner
                            this.reply = result.reply
                            this.unitother = result.unitother
                            this.businessLicenseMst = result.businessLicenseMst
                            this.unitpropertyOwnerMst = result.unitpropertyOwnerMst
                            this.replyMst = result.replyMst
                            this.unitotherMst = result.unitotherMst
                
                        }
                        console.log(this.active1)
                        this.$clear()
                    }else{
                        this.$toast(res.msg)
                    }
                })
            },
            onChanquanren() {
                this.form.fnetapplytype = 1
                this.chanquanren = true
                this.shenqingren = false
            },
            onShenqingren() {
                this.form.foper = this.form.fname
                this.form.fnetapplytype = 2
                this.chanquanren = false
                this.shenqingren = true
            },
            onClick() {

            },
            // 验表原因
            getFnetType(){
                this.fnettypeColumns = []
                this.$http.post(this.$api.getBasedata, {
                    "typeid":10,
                    "parentid":0
                }).then(res => {
                    if (res.code==='000') {
                    res.data.forEach(el => {
                        this.fnettypeColumns.push({
                            text:el.fname,
                            code:el.fid
                        })
                    })
                    } else {
                        this.$toast(res.msg)
                    }
                })
            },
            // 个人验表原因选择
            fnettypeConfirm(obj,index){
                this.fnettype = obj.text
                this.form.fnettype = this.fnettypeColumns[index].code
                console.log(this.form.fnettype)
                this.fnettypeShow = false
            },
            // 单位验表原因选择
            unitFnettypeConfirm(obj,index){
                this.unitfnettype = obj.text
                this.unitForm.fnettype = this.fnettypeColumns[index].code
                console.log(this.unitForm.fnettype)
                this.fnettypeShow = false
            },
            // 身份证正面
            cardPositiveAfter(file) {
                this.$loading('上传中...')
                this.$http.post(this.$api.fileuploadbase64, {
                    fileext: this.$comm.extname(file.file.name),
                    base64: file.content
                }).then(res => {
                    this.$clear()
                    if (res.code === '000') {
                        this.cardPositive.push({ url: res.data})
                    } else {
                        this.$toast('上传失败')
                    }
                })
            },
            cardPositiveDelete(file, detail) {
                this.cardPositive.splice(detail.index, 1)
            },
            // 身份证反面
            cardAntiAfter(file) {
                this.$loading('上传中...')
                this.$http.post(this.$api.fileuploadbase64, {
                    fileext: this.$comm.extname(file.file.name),
                    base64: file.content
                }).then(res => {
                    this.$clear()
                    if (res.code === '000') {
                        this.cardAnti.push({url: res.data})
                    } else {
                        this.$toast('上传失败')
                    }
                })
            },
            cardAntiDelete(file, detail) {
                this.cardAnti.splice(detail.index, 1)
            },
            // 产权证明
            propertyOwnerAfter(file) {
                this.$loading('上传中...')
                this.$http.post(this.$api.fileuploadbase64, {
                    fileext: this.$comm.extname(file.file.name),
                    base64: file.content
                }).then(res => {
                    this.$clear()
                    if (res.code === '000') {
                        this.propertyOwner.push({url: res.data})
                    } else {
                        this.$toast('上传失败')
                    }
                })
            },
            propertyOwnerDelete(file, detail) {
                this.propertyOwner.splice(detail.index, 1)
            },
            // 其他证明
            otherAfter(file) {
                this.$loading('上传中...')
                this.$http.post(this.$api.fileuploadbase64, {
                    fileext: this.$comm.extname(file.file.name),
                    base64: file.content
                }).then(res => {
                    this.$clear()
                    if (res.code === '000') {
                        this.other.push({url: res.data})
                    } else {
                        this.$toast('上传失败')
                    }
                })
            },
            otherDelete(file, detail) {
                this.other.splice(detail.index, 1)
            },
            // 获取用户信息
            onSelectClick(user) {
                this.popShow = false
                if(this.active1 == 0){
                    this.form.fpactno = user.fpactno
                    this.form.fuserno = user.fuserno
                    this.form.fname = user.fname
                    this.form.ffixaddr = user.ffixaddr
                    this.form.fwaterid = user.fwaterid
                    this.form.fwater = user.fwater
                }else{
                    this.unitForm.fpactno = user.fpactno
                    this.unitForm.fuserno = user.fuserno
                    this.unitForm.fname = user.fname
                    this.unitForm.ffixaddr = user.ffixaddr
                    this.unitForm.fwaterid = user.fwaterid
                    this.unitForm.fwater = user.fwater
                }
            },
            choiceClick() {
                this.popShow = true
            },
            // 个人选择预约时间
            userOnConfirm(value){
                var year = value.getFullYear()
                var month =(value.getMonth() + 1).toString()
                var day = (value.getDate()).toString()
                if (month.length == 1) { 
                    month = "0" + month
                } 
                if (day.length == 1) { 
                    day = "0" + day
                }
                var dateTime = year + "-" + month + "-" + day
                this.form.fappointment = dateTime
                this.showPicker = false
                console.log(value,dateTime)
            },
            // 个人提交
            userOnSubmit() {
                this.form.attach = []
                if(this.cardPositive.length<=0 || this.cardPositive.length<2){
                    this.$toast('产权人身份证正反面不能为空')
                    return
                }
                this.form.attach.push({
                    typeid:1,
                    url:this.cardPositive[0].url + ',' + this.cardPositive[1].url
                })
                if(this.propertyOwner.length<=0){
                    this.$toast('产权证明不能为空')
                    return
                }else{
                    let url = ''
                    this.propertyOwner.forEach(el=>{
                        if(url){
                            url = url + ',' + el.url
                        }else{
                            url = el.url
                        }
                    })
                    this.form.attach.push({
                        typeid:2,
                        url:url
                    })
                }
                if(this.other.length>0){
                    let url = ''
                    this.other.forEach(el=>{
                        if(url){
                            url = url + ',' + el.url
                        }else{
                            url = el.url
                        }
                    })
                    this.form.attach.push({
                        typeid:13,
                        url:url
                    })
                }
                if(this.form.fnetapplytype === '1'){
                    this.form.foper = this.form.fname
                    console.log(this.form.foper)
                }
                console.log(this.form)
                this.$http.post(this.$api.checkmeter, this.form).then(res => {
                    if (res.code === '000') {
                        this.$router.push({
                            path: '/business/success',
                            query: {
                                title: this.$route.meta.title,
                                from: '业务办理'
                            }
                        })
                    } else {
                        this.$toast(res.msg)
                    }
                })
            },
            // 营业执照
            businessLicenseAfter(file) {
                this.$loading('上传中...')
                this.$http.post(this.$api.fileuploadbase64, {
                    fileext: this.$comm.extname(file.file.name),
                    base64: file.content
                }).then(res => {
                    this.$clear()
                    if (res.code === '000') {
                        this.businessLicense.push({ url: res.data})
                    } else {
                        this.$toast('上传失败')
                    }
                })
            },
            businessLicenseDelete(file, detail) {
                this.businessLicense.splice(detail.index, 1)
            },
            // 单位产权证明
            unitpropertyOwnerAfter(file) {
                this.$loading('上传中...')
                this.$http.post(this.$api.fileuploadbase64, {
                    fileext: this.$comm.extname(file.file.name),
                    base64: file.content
                }).then(res => {
                    this.$clear()
                    if (res.code === '000') {
                        this.unitpropertyOwner.push({url: res.data})
                    } else {
                        this.$toast('上传失败')
                    }
                })
            },
            unitpropertyOwnerDelete(file, detail) {
                this.unitpropertyOwner.splice(detail.index, 1)
            },
            // 单位其他证明
            unitotherAfter(file) {
                this.$loading('上传中...')
                this.$http.post(this.$api.fileuploadbase64, {
                    fileext: this.$comm.extname(file.file.name),
                    base64: file.content
                }).then(res => {
                    this.$clear()
                    if (res.code === '000') {
                        this.unitother.push({url: res.data})
                    } else {
                        this.$toast('上传失败')
                    }
                })
            },
            unitotherDelete(file, detail) {
                this.unitother.splice(detail.index, 1)
            },
            // 单位选择预约时间
            unitOnConfirm(value){
                var year = value.getFullYear()
                var month =(value.getMonth() + 1).toString()
                var day = (value.getDate()).toString()
                if (month.length == 1) { 
                    month = "0" + month
                } 
                if (day.length == 1) { 
                    day = "0" + day
                }
                var dateTime = year + "-" + month + "-" + day
                this.unitForm.fappointment = dateTime
                this.showPicker = false
                console.log(value,dateTime)
            },
            // 单位提交
            unitOnSubmit() {
                this.unitForm.attach = []
                if(this.businessLicense.length<=0){
                    this.$toast('营业执照不能为空')
                    return
                }
                this.unitForm.attach.push({
                    typeid:3,
                    url:this.businessLicense[0].url
                })
                if(this.unitpropertyOwner.length<=0){// 单位产权证明
                    this.$toast('产权证明不能为空')
                    return
                }else{ // 单位产权证明
                    let url = ''
                    this.unitpropertyOwner.forEach(el=>{
                        if(url){
                            url = url + ',' + el.url
                        }else{
                            url = el.url
                        }
                    })
                    this.unitForm.attach.push({
                        typeid:2,
                        url:url
                    })
                }
                if(this.unitother.length>0){ // 单位其他材料
                    let url = ''
                    this.unitother.forEach(el=>{
                        if(url){
                            url = url + ',' + el.url
                        }else{
                            url = el.url
                        }
                    })
                    this.unitForm.attach.push({
                        typeid:13,
                        url:url
                    })
                }
                console.log(this.unitForm)
                this.$http.post(this.$api.checkmeter, this.unitForm).then(res => {
                    if (res.code === '000') {
                        this.$router.push({
                            path: '/business/success',
                            query: {
                                title: this.$route.meta.title,
                                from: '业务办理'
                            }
                        })
                    } else {
                        this.$toast(res.msg)
                    }
                })
            },
        },
    }
</script>

<style lang="less" scoped>
    .meter-transfer-form {
        /deep/ .van-radio-group.van-radio-group--horizontal {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(33, 33, 33, 1);

            .van-radio--horizontal {
                margin-right: 0;
                margin-left: 4px;

                .van-radio__label {
                    margin-left: 2px;
                }
            }
        }

        .form-pop {
            width: 85%;
            height: 60%;
            border-radius: 4px;
            font-size: 12px;
        }
    }
</style>